import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: "70px",
    ...shorthands.gap("12px"),
    ...shorthands.padding("0px", "18px", "0px", "18px"),
    paddingTop: "15px",
    paddingBottom: "15px",
  },
  info: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    height: "auto",
    width: "100%",
  },
  removeButton: {
    ...shorthands.padding(0),
    minWidth: "24px",
    color: tokens.colorPaletteRedForeground1,
    paddingTop: "5px",
  },
  editButton: {
    ...shorthands.padding(0),
    minWidth: "24px",
    color: tokens.colorBrandForeground1,
    paddingTop: "5px",
  },

  subTitle: {
    maxWidth: "70vw",
    color: tokens.colorNeutralForeground1,
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row-reverse",
    ...shorthands.gap("10px"),
  },
  customInstructions: {
    color: tokens.colorNeutralForeground4,
  },
  visuallyHidden: {
    position: "absolute",
    width: "1px",
    height: "1px",
    ...shorthands.padding("0"),
    ...shorthands.margin("-1px"),
    ...shorthands.overflow("hidden"),
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    ...shorthands.borderWidth("0"),
  },
});
